module.exports = __webpack_public_path__ + "static/media/campos-do-jordao-sp.cfe7fb63.jpg";